import React, { FC, useRef } from 'react';

import { Select } from 'chakra-react-select';
import { FormControl, FormLabel } from '@chakra-ui/react';

import { washHub } from 'store';

import { useWashhubsForSKU } from 'hooks';

import { useFormikContext } from 'formik';

import {
  InputType,
  ChakraStyles,
  WashHubSelectProps,
} from './WashHubSelect.props';
import { Location } from 'types/washhub';

const chakraStyles: ChakraStyles = {
  dropdownIndicator: (_props) => ({
    ..._props,
    bg: 'transparent',
  }),
  option: (_props) => ({
    ..._props,
    padding: '10px',
    borderBottom: '1px solid #ccc',
  }),
  menuList: (_props) => ({
    ..._props,
    padding: '0px',
    overflow: 'hidden',
  }),
};

const mapWashhubs = (washhubItem: Location) => ({
  label: washhubItem.name,
  value: washhubItem._id,
});

const WashHubSelectView: FC<WashHubSelectProps> = ({
  packageId,
  isCreateForm,
}) => {
  const isDataFetchRef = useRef<boolean>(false);
  const selectInputRef = useRef<InputType>(null);
  const savedWashhubsRef = useRef<Array<string>>([]);

  const { setFieldValue } = useFormikContext<any>();

  const allWashhubs = washHub.selectors.useAllWashHubs();

  const { isFetching } = useWashhubsForSKU(packageId || '', {
    onSuccess: (response) => {
      selectInputRef.current?.setValue(
        response.map(mapWashhubs),
        'select-option',
      );

      savedWashhubsRef.current = response.map((w) => w._id);

      isDataFetchRef.current = true;
    },
  });

  const options = allWashhubs?.map(mapWashhubs);

  return (
    <FormControl mt={8} isRequired>
      <FormLabel
        htmlFor="packages"
        textTransform="capitalize"
        fontSize="12px"
        color="#afafaf">
        Assigned WashHubs
      </FormLabel>
      <Select
        isMulti
        ref={selectInputRef}
        options={options}
        isLoading={isFetching}
        isDisabled={isFetching}
        tagVariant="solid"
        colorScheme="primary"
        closeMenuOnSelect={false}
        chakraStyles={chakraStyles}
        onChange={(newValue) => {
          // if (isDataFetchRef.current === false) {
          //   return;
          // }

          const washHubIds = newValue.map((n) => n.value);

          if (isCreateForm === true) {
            setFieldValue('washHubs', washHubIds);
            return;
          }

          const washHubsToBeAdded = washHubIds.filter(
            (w) => !savedWashhubsRef.current.includes(w),
          );

          const washHubsToBeRemoved = savedWashhubsRef.current.filter(
            (w) => !washHubIds.includes(w),
          );

          if (washHubsToBeAdded.length > 0) {
            setFieldValue('washHubsToBeAdded', washHubsToBeAdded);
          }

          if (washHubsToBeRemoved.length > 0) {
            setFieldValue('washHubsToBeRemoved', washHubsToBeRemoved);
          }
        }}
      />
    </FormControl>
  );
};

export default WashHubSelectView;
